<template>
    <section class="">
        <div class="assessmentContent">
            <div class="pageContent mobile-padding">

                <img class="helpEquipment-section-image"
                     src="/img/adt-logo.svg"
                     alt="ADT Logo">

                <div class="helpTitle">
                    Monitored by the #1 security company in America.
                </div>

                <div class="monitoring-plans-subtitle">
                    My 24/7 professional monitoring plan
                    <div class="monitoring-plans-subtitle-extra">
                        This monitoring plan was selected based on the features you selected for your system.
                    </div>
                </div>

                <!-- SELECTED MONITORING PLAN -->

                <MonitoringPlanCard v-if="selectedPlan"
                                      :id="selectedPlan.id"
                                      :type="selectedPlan.type"
                                      :selected="selectedPlan.selected"
                                      :features="selectedPlan.features || null"
                                      :level="selectedPlan.level"
                                      :price="selectedPlan.price"
                                      :description="selectedPlan.description" />

                <div class="looking-for-cheaper-plan"
                     v-if="selectedPlan.type == 'pulse'">
                    Looking for a cheaper plan? try regular <a href="#">Cellular Monitoring for $47.99</a>
                </div>

            </div>
        </div>


        <div class="learn-more-pulse">
            Learn more about ADT Pulse levels
        </div>

        <section class="assessmentContent">

            <div class="pageContent mobile-padding">
                <div class="pulse-description">
                    Your ADT Pulse plan is determined based on the features you select. As you upgrade your system, your plan will match the features you select.
                </div>

                <MonitoringPlanCard v-for="plan in pulsePlans"
                                      :id="plan.id"
                                      key="plan.id"
                                      :type="plan.type"
                                      :selected="plan.selected"
                                      :level="plan.level"
                                      :price="plan.price"
                                      :description="plan.description" />


                <div class="monitoring-hr">
                    <hr>
                </div>

                <div class="cheaper-plans-title">
                    Looking for cheaper monitoring without the extra features?
                </div>

                <MonitoringPlanCard v-for="plan in traditionalPlans"
                                      :id="plan.id"
                                      key="plan.id"
                                      :type="plan.type"
                                      :selected="plan.selected"
                                      :level="plan.level"
                                      :price="plan.price"
                                      :description="plan.description" />
            </div> 
        </section>

    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MonitoringPlanCard from '../components/MonitoringPlanCard.vue'
export default {
    components: {
        MonitoringPlanCard
    },
    computed: {
        ...mapState(["system"]),
        ...mapGetters(["selectedPlan", "pulsePlans", "traditionalPlans"])
    },
    methods: {
        ...mapActions(["updateSystem"])
    },
    mounted () {
        if (this.system.monitoringPlans.length < 1) {
            this.updateSystem();
        }
        mixpanel.track("inspectedMonitoring")
    }
};
</script>

<style lang="css"></style>
